export default {
  journalEntries: [],
  journalEntriesLoadingStatus: false,
  accountPayablesAC: []
}
